import cx from 'classnames'
import type { ComponentProps } from 'react'
import type { ButtonProps } from 'react-aria-components'

import { IconButton } from '../../../actions/iconButton/IconButton'

type Props = Pick<
  ButtonProps,
  'aria-label' | 'onPress' | 'excludeFromTabOrder' | 'preventFocusOnPress'
> & {
  tip: ComponentProps<typeof IconButton>['tip']
  iconName: ComponentProps<typeof IconButton>['iconName']
  isDisabled?: boolean
  className?: string
}

/** Compact icon button placed inside an input, e.g. a clear button or a dropdown/calendar trigger. */
export const InsideInputIconButton = ({
  tip,
  iconName,
  isDisabled,
  className,
  'aria-label': ariaLabel,
  onPress,
  excludeFromTabOrder,
  preventFocusOnPress,
}: Props) => (
  <IconButton
    tip={tip}
    iconName={iconName}
    iconSize="sm"
    disabled={isDisabled}
    className={cx('p-0.5! text-current!', className)}
    extraProps={{
      'aria-label': ariaLabel,
      onPress,
      excludeFromTabOrder,
      preventFocusOnPress,
    }}
  />
)
